/* src/modules/discounts/action_types.js */

export const fetchDiscountHoldersTypes = [
  'FETCH_DISCOUNTS_HOLDERS',
  'FETCH_DISCOUNTS_HOLDERS_SUCCESS',
  'FETCH_DISCOUNTS_HOLDERS_FAIL',
];

export const fetchSeasonsTypes = [
  'FETCH_SEASONS',
  'FETCH_SEASONS_SUCCESS',
  'FETCH_SEASONS_FAIL',
];

export const createSeasonTypes = [
  'CREATE_SEASON',
  'CREATE_SEASON_SUCCESS',
  'CREATE_SEASON_FAIL',
];

export const createDiscountHolderTypes = [
  'CREATE_DISCOUNT_HOLDER',
  'CREATE_DISCOUNT_HOLDER_SUCCESS',
  'CREATE_DISCOUNT_HOLDER_FAIL',
];

export const createDiscountTypes = [
  'CREATE_DISCOUNT',
  'CREATE_DISCOUNT_SUCCESS',
  'CREATE_DISCOUNT_FAIL',
];

export const modifyActiveDiscountTypes = [
  'MODIFY_ACTIVE_DISCOUNT',
  'MODIFY_ACTIVE_DISCOUNT_SUCCESS',
  'MODIFY_ACTIVE_DISCOUNT_FAIL',
];

export const modifyDiscountHolderTypes = [
  'MODIFY_DISCOUNT_HOLDER',
  'MODIFY_DISCOUNT_HOLDER_SUCCESS',
  'MODIFY_DISCOUNT_HOLDER_FAIL',
];

export const SELECT_DISCOUNT_HOLDER = 'SELECT_DISCOUNT_HOLDER';



// WEBPACK FOOTER //
// ./src/modules/discounts/action_types.js